import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Skeleton } from "@/components/BookingShell";
import { StaffLayout } from "@/pages/staff/StaffLayout";
import { StaffLogin } from "@/pages/staff/StaffLogin";
import { StaffForgotPassword } from "@/pages/staff/StaffForgotPassword";
import { StaffResetPassword } from "@/pages/staff/StaffResetPassword";
import { StaffDashboard } from "@/pages/staff/pages/Dashboard";
import { StaffCalendar } from "@/pages/staff/pages/Calendar";
import { StaffAppointments } from "@/pages/staff/pages/Appointments";
import { StaffAppointmentDetail } from "@/pages/staff/pages/AppointmentDetail";
import { StaffCustomers } from "@/pages/staff/pages/Customers";
import { StaffCustomerDetail } from "@/pages/staff/pages/CustomerDetail";
import { StaffServices } from "@/pages/staff/pages/Services";
import { StaffAvailability } from "@/pages/staff/pages/Availability";
import { StaffPayments } from "@/pages/staff/pages/Payments";
import { StaffReports } from "@/pages/staff/pages/Reports";
import { StaffManualBooking } from "@/pages/staff/pages/ManualBooking";
import { FormReviews } from "@/pages/staff/pages/FormReviews";
import { StaffForms } from "@/pages/staff/pages/Forms";
import { StaffFormBuilder } from "@/pages/staff/pages/FormBuilder";
import { StaffFormCategories } from "@/pages/staff/pages/FormCategories";
import { StaffCommunications } from "@/pages/staff/pages/communications";
import { AppointmentCheckout } from "@/pages/staff/pages/AppointmentCheckout";
import { AutomationSettings } from "@/pages/staff/pages/AutomationSettings";
import { CommunicationDefaults } from "@/pages/staff/pages/CommunicationDefaults";
import { StaffMarketing } from "@/pages/staff/pages/Marketing";
import { StaffApp } from "@/pages/staff/pages/StaffApp";
import { StaffStartup } from '@/components/StaffStartup';
import {CancellationPolicy, CancellationRefunds} from './pages/CancellationPolicy';
import {Reviews} from './pages/Reviews';

function ProtectedShell() {
    const { user, checking } = useAuth();
    if (checking) return <div className="p-10"><Skeleton className="h-64" /></div>;
    if (!user) return <Navigate to="/staff/login" replace />;
    return <StaffLayout />;
}

export function StaffRoutes() {
    return (
        <><StaffStartup /><Routes>
            <Route path="login" element={<StaffLogin />} />
            <Route path="forgot-password" element={<StaffForgotPassword />} />
            <Route path="reset-password" element={<StaffResetPassword />} />
            <Route element={<ProtectedShell />}>
                <Route index element={<StaffDashboard />} />
                <Route path="calendar" element={<StaffCalendar />} />
                <Route path="appointments" element={<StaffAppointments />} />
                <Route path="appointments/:id" element={<StaffAppointmentDetail />} />
                <Route path="appointments/:id/checkout" element={<AppointmentCheckout />} />
                <Route path="customers" element={<StaffCustomers />} />
                <Route path="customers/:id" element={<StaffCustomerDetail />} />
                <Route path="services" element={<StaffServices />} />
                <Route path="availability" element={<StaffAvailability />} />
                <Route path="payments" element={<StaffPayments />} />
                <Route path="reports/*" element={<StaffReports />} />
                <Route path="booking/new" element={<StaffManualBooking />} />
                <Route path="forms/review" element={<FormReviews />} />
                <Route path="forms" element={<StaffForms />} />
                <Route path="forms/categories" element={<StaffFormCategories />} />
                <Route path="forms/:id" element={<StaffFormBuilder />} />
                <Route path="communications/*" element={<StaffCommunications />} />
                <Route path="settings/automations" element={<AutomationSettings />} />
                <Route path="settings/communications" element={<CommunicationDefaults />} />
                <Route path="marketing" element={<StaffMarketing />} />
                <Route path="settings/app" element={<StaffApp />} />
                <Route path="settings/cancellation" element={<CancellationPolicy />} />
                <Route path="refunds" element={<CancellationRefunds />} />
                <Route path="reviews" element={<Reviews />} />
            </Route>
        </Routes></>
    );
}
